/* eslint-disable no-lone-blocks */
import React, { useContext, useEffect, useState } from 'react';
import {
  ExpandLessRounded, ExpandMoreRounded, VisibilityOffOutlined, VisibilityOutlined,
} from '@mui/icons-material';
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Snackbar,
  TextField,
} from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import 'react-medium-image-zoom/dist/styles.css';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Images from '../../../../Configs/images';
import Elements from '../../../Elements';
import ROUTES from '../../../../Configs/routes';
import {
  getAdminRequestDetails, assignCourier, assignItemsToBox, setRequestAsDone,
} from '../../../../Redux/Models/request';
import { getCourier } from '../../../../Redux/Models/courier';
import { getDigitalBox } from '../../../../Redux/Models/box';
import { BoxItemData } from '../../Courier/RequestDetails/RequestDetails';
import { getCategories, getConditions } from '../../../../Redux/Models/master';
import ConfirmationContext from '../../../../Context/ConfirmationContext';

export default function RequestOut({
  classes, selectedRequest, courierSelected, isLoading, error, message, validatedRequest,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { requestId } = useParams();
  const [activeStep, setActiveStep] = useState(1);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [unproceed, setUnproceed] = useState(false);
  const [choosenCourier, setChoosenCourier] = useState({ front_name: '', id: '' });

  const [showLeftCode, setShowLeftCode] = useState(false);
  const [showRightCode, setShowRightCode] = useState(false);
  const { openConfirmation, closeConfirmation } = useContext(ConfirmationContext);

  const initItem = {
    item1: {},
  };
  const [boxes, setBoxes] = useState({
    'box-1': initItem,
  });

  const { couriers } = useSelector((state) => state.courier);

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const closeModalConfirm = () => {
    setOpenConfirm(false);
  };

  const changeStep = (newStep) => () => {
    setActiveStep(newStep);
    closeModalConfirm();
  };

  useEffect(() => {
    const courierOnIt = ['Waiting for Courier Acceptance', 'Courier On The Way', 'Courier Arrived at Pickup Place', 'Courier Arrived at Customer Place', 'Request going back to the warehouse'];
    if (courierOnIt.indexOf(selectedRequest.status) > -1) {
      changeStep(2)();
    } else if (selectedRequest.status === 'Item Already Confirm by Customer') {
      changeStep(4)();
    } else if (selectedRequest.status === 'Done') {
      changeStep(3)();
      openConfirmation({
        title: 'The request process has done',
        desc: 'You can back to home',
        confirmText: 'Ok, go back',
        cancelText: 'Stay here',
        handleAgree: () => {
          navigate(ROUTES.home());
          closeConfirmation();
        },
        handleClose: () => {
          closeConfirmation();
        },
      });
    } else if (selectedRequest.status === 'Stored at Warehouse') {
      changeStep(4)();
    }

    if (selectedRequest.items) {
      const newBoxes = {};
      const total = [];
      Object.keys(selectedRequest.items).forEach((boxKey) => {
        let index = 1;
        const items = {};
        selectedRequest.items[boxKey].forEach((item) => {
          items[`item${index}`] = item;
          index += 1;
          total.push(item.id);
        });

        newBoxes[boxKey] = items;
      });

      setBoxes(newBoxes);
    }
  }, [selectedRequest]);

  const getInitialData = () => {
    dispatch(getAdminRequestDetails(requestId));
    dispatch(getCourier());
    dispatch(getDigitalBox());
    dispatch(getCategories());
    dispatch(getConditions());
  };

  useEffect(() => {
    if (!requestId) {
      navigate(-1);
    } else {
      getInitialData();
    }
  }, [requestId]);

  const getImage = (name, step) => {
    if (step === activeStep) return Images[`${name}Active2`];
    if (step > activeStep) return Images[name];
    return Images.Check2;
  };

  const handleAssignCourier = () => {
    dispatch(assignCourier(requestId, { courier: choosenCourier.id }));
  };

  const [hideReqInfo, setHideRI] = useState(false);
  const [hideOwnerInfo, setHideOI] = useState(false);
  const [hideItemInfo, setHideII] = useState(false);
  const [hideTrackHistory, setHideTH] = useState(false);

  useEffect(() => {
    if (courierSelected) {
      dispatch(getAdminRequestDetails(requestId));
      setOpenConfirm(false);
    }
  }, [courierSelected]);

  useEffect(() => {
    if (activeStep >= 2) {
      setHideRI(true);
      setHideOI(true);
      setHideII(true);
    } else {
      setHideRI(false);
      setHideOI(false);
      setHideII(false);
    }
  }, [activeStep]);

  const updateStatus = () => {
    // const body = {
    //   status,
    // };
    dispatch(setRequestAsDone(requestId));
  };

  const wantToContinue = () => {
    let valid = false;
    const showAlert = (mssg) => {
      setSnackbar({
        open: true,
        message: mssg,
        severity: 'error',
      });
    };

    switch (activeStep) {
      case 1: if (selectedRequest.delivery_type?.icon === 'warehouse') {
        changeStep(4)();
      } else valid = true;
        break;
      case 2: {
        if (selectedRequest.driver) {
          changeStep(3)();
        } else {
          valid = choosenCourier.id;
          if (!valid) {
            showAlert('Please choose courier!');
          }
        }
      }
        break;
      case 3:
        valid = true;
        break;
      case 4:
        if (selectedRequest.delivery_type?.icon === 'warehouse') {
          updateStatus('Done');
        } else {
          valid = true;
        }
        break;
      default: valid = false;
    }

    if (valid) {
      setOpenConfirm(true);
    }
  };

  const [digitalBox, setDigitalBox] = useState([]);

  const handleDigitalBox = (newVal) => {
    if (newVal.row && newVal.column) {
      const filteredDigiBox = digitalBox.filter(
        (db) => db.row === newVal.row && db.column === newVal.column,
      );
      const existingDigiBox = Boolean(filteredDigiBox.length);
      if (existingDigiBox) {
        // update box
        const newDigiBoxes = digitalBox.map((db) => {
          if (db.row === newVal.row && db.column === newVal.column) {
            return newVal;
          }
          return db;
        });
        setDigitalBox(newDigiBoxes);
      } else {
        // add box
        const newDigiBoxes = [...digitalBox];
        newDigiBoxes.push(newVal);
        setDigitalBox(newDigiBoxes);
      }
    }
  };

  const handleAssignItemsToBox = () => {
    const body = {
      owner_id: selectedRequest.user?.id,
      digital_box: {
        ...digitalBox,
        box: selectedRequest?.box.id,
      },
    };
    dispatch(assignItemsToBox(requestId, body));
  };

  useEffect(() => {
    if (validatedRequest === requestId) {
      setSnackbar({
        open: true,
        message: 'Request out success',
        severity: 'success',
      });
      getInitialData();
      closeModalConfirm();
    }

    if (error) {
      setSnackbar({
        open: true,
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [validatedRequest, error]);

  const renderRequestInfo = () => (
    <div className="info-card mt-3">
      <div className="flex space-between link" onClick={() => setHideRI(!hideReqInfo)}>
        <h3>Request Info</h3>
        {hideReqInfo
          ? <ExpandMoreRounded fontSize="medium" />
          : <ExpandLessRounded fontSize="medium" />}
      </div>
      <div hidden={hideReqInfo}>
        <Divider sx={{ my: 2 }} />
        <div className="flex space-between align-items-center">
          <div className="flex align-items-center gap-4">
            <img src={Images.RequestOutRounded2} alt="req-in" />
            <div className="s-14 weight-500">Request out</div>
          </div>
          <div className="status">{selectedRequest.status}</div>
        </div>

        <div className="flex space-between align-items-center space-between mt-3 gap-16">
          <div className="flex-1">
            <div className="mute s-12">Request ID</div>
            <div className="weight-700 mt-1">{selectedRequest.id}</div>
          </div>
          <div className="flex-1">
            <div className="mute s-12">Request date</div>
            <div className="weight-700 mt-1">{moment(new Date(selectedRequest.pickup_date)).format('HH.mm - DD/MM/YYYY')}</div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderOwnerInfo = () => (
    <div className="info-card mt-3">
      <div className="flex space-between link" onClick={() => setHideOI(!hideOwnerInfo)}>
        <h3>Owner Info</h3>
        {hideOwnerInfo
          ? <ExpandMoreRounded fontSize="medium" />
          : <ExpandLessRounded fontSize="medium" />}
      </div>
      <div hidden={hideOwnerInfo}>
        <Divider sx={{ my: 2 }} />
        <div className="flex space-between align-items-center">
          <div>
            <div className="mute s-12">User ID</div>
            <div className="weight-700 mt-1">{selectedRequest.user?.id}</div>
          </div>
          <div className="plan flex align-items-center gap-4">
            <img alt="subs" src={selectedRequest.user?.subscription === 'Normal Plan' ? Images.NormalStar : Images.PremiumStar} height="24" />
            <div className="s-14 weight-500">{selectedRequest.user?.subscription}</div>
          </div>
        </div>
        <div className="mt-3">
          <div className="mute s-12">User name</div>
          <div className="weight-700 mt-1">{`${selectedRequest.user?.front_name} ${selectedRequest.user?.back_name}`}</div>
        </div>
        <div className="flex space-between align-items-center mt-3">
          <div>
            <div className="mute s-12">Phone number</div>
            <div className="weight-700 mt-1">{selectedRequest.user?.phone_number}</div>
          </div>
          <img src={Images.PhoneOrange} alt="phone" />
        </div>
        <div className="flex space-between align-items-center mt-3">
          <div>
            <div className="mute s-12">Pick up address</div>
            <div className="weight-700 mt-1">{selectedRequest.pickup_address?.address}</div>
          </div>
          <img src={Images.LocationOrange} alt="Pick up address" />
        </div>
      </div>
    </div>
  );

  const renderItemInfo = () => (
    <div className="info-card mt-3">
      <div className="flex space-between link" onClick={() => setHideII(!hideItemInfo)}>
        <h3>Item Info</h3>
        {hideItemInfo
          ? <ExpandMoreRounded fontSize="medium" />
          : <ExpandLessRounded fontSize="medium" />}
      </div>
      <div hidden={hideItemInfo}>
        <Divider sx={{ my: 2 }} />
        <div className="flex gap-20 align-items-start">
          <img alt="req-in" src={Images.RequestOutActive2} />
          {selectedRequest.box
            ? (
              <Box display="flex" gap={1.5} mt={1.5} alignItems="flex-start">
                <img width="80px" height="80px" className="rounded cover" src={selectedRequest.box?.photo || 'https://images.pexels.com/photos/2912108/pexels-photo-2912108.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500'} alt="box" />
                <Box flex={1}>
                  <div className="weight-600">
                    {selectedRequest.box?.name || `Box ${selectedRequest.box?.digital_box_id}`}
                  </div>
                  <Box>
                    {selectedRequest.box?.amount}
                    {' '}
                    Items
                  </Box>
                </Box>
              </Box>
            )
            : (
              <div className="flex-1">
                <div className="flex space-between">
                  <div className="flex-1">
                    <div className="mute s-12">Item status</div>
                    <div className="mt-1 inline-block">
                      <div className="pil flex align-items-center gap-4">
                        <img src={Images.VerifiedIcon} alt="verified" height="20" />
                        <div className="s-12">
                          Verified items
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="mute s-12">Left code</div>
                    <div className="flex gap-16">
                      <div className="weight-700 mt-1">{showLeftCode ? selectedRequest.lock_left : '*****'}</div>
                      <IconButton sx={{ p: 0 }} onClick={() => setShowLeftCode(!showLeftCode)} size="small">
                        {showLeftCode
                          ? <VisibilityOutlined />
                          : <VisibilityOffOutlined />}
                      </IconButton>
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="mute s-12">Right code</div>
                    <div className="flex gap-16">
                      <div className="weight-700 mt-1">{showRightCode ? selectedRequest.lock_right : '*****'}</div>
                      <IconButton sx={{ p: 0 }} onClick={() => setShowRightCode(!showRightCode)} size="small">
                        {showRightCode
                          ? <VisibilityOutlined />
                          : <VisibilityOffOutlined />}
                      </IconButton>
                    </div>
                  </div>
                </div>
                <div className="flex space-between mt-3">
                  <div className="flex-1">
                    <div className="mute s-12">Category</div>
                    <div className="weight-700 mt-1">{selectedRequest.category?.name}</div>
                  </div>
                  <div className="flex-1">
                    <div className="mute s-12">Volume</div>
                    <div className="weight-700 mt-1">
                      {selectedRequest.amount}
                      {' '}
                      ml
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="mute s-12">Item condition</div>
                    <div className="weight-700 mt-1">{selectedRequest.condition?.name}</div>
                  </div>
                </div>
                <div className="flex space-between mt-3">
                  <div className="flex-1">
                    <div className="mute s-12">Row</div>
                    <div className="weight-700 mt-1">{selectedRequest.row}</div>
                  </div>
                  <div className="flex-1">
                    <div className="mute s-12">Column</div>
                    <div className="weight-700 mt-1">
                      {selectedRequest.column}
                    </div>
                  </div>
                  <div className="flex-1" />
                </div>
                <div className="mt-3">
                  <div className="mute s-12">Item notes</div>
                  <div className="weight-700 mt-1">{selectedRequest.item_notes || '-'}</div>
                </div>
                <div className="mt-3">
                  <div className="mute s-12">Pickup notes</div>
                  <div className="weight-700 mt-1">{selectedRequest.pickup_notes || '-'}</div>
                </div>
              </div>
            )}
        </div>

        <div>
          {Object.keys(boxes).map((key, index) => (
            <BoxToValidate
              key={index}
              index={index}
              selectedBox={boxes[key]}
              classes={classes}
              updateDigitalBox={handleDigitalBox}
            />
          ))}
        </div>
      </div>

    </div>
  );

  const renderCourierSection = () => {
    if (selectedRequest.driver) {
      return (
        <div className="info-card mt-3">
          <h3>Track courier</h3>
          <Divider sx={{ my: 2 }} />
          <div className="flex align-items-start gap-16">
            <img src={selectedRequest.driver?.profile_picture} alt="driver" height="48" width="48" className="circle cover" />
            <div className="flex-1">
              <div className="flex space-between">
                <div>
                  <div className="s-12 mute">Courier name</div>
                  <div className="s-16 weight-700 mt-2">{selectedRequest.driver?.front_name}</div>
                </div>
                <div>
                  <div className="s-12 mute">Courier ID</div>
                  <div className="s-16 weight-700 mt-2">
                    {selectedRequest.driver?.id}
                  </div>
                </div>
                <div>
                  <div className="s-12 mute">Status</div>
                  <div className="s-12 weight-500 mt-2 pil">{selectedRequest.status}</div>
                </div>
              </div>
              <div className="mt-3">
                <div className="s-12 mute">Phone number</div>
                <div className="s-16 weight-700 mt-2">{selectedRequest.driver?.phone_number}</div>
              </div>
            </div>
          </div>
          <Box sx={{
            borderRadius: 2,
            border: '1px solid #DADADA',
            p: 2,
            mt: 2,
          }}
          >
            <div className="flex space-between link" onClick={() => setHideTH(!hideTrackHistory)}>
              <h3>Track history</h3>
              {hideTrackHistory
                ? <ExpandMoreRounded fontSize="medium" />
                : <ExpandLessRounded fontSize="medium" />}
            </div>
            <div hidden={hideTrackHistory}>
              <Divider sx={{ my: 2 }} />
              <div className="stepper">
                {selectedRequest.tracking_history.map((history, idx) => (
                  <div className="flex gap-16 mt-2" key={history.timestamp}>
                    <img src={idx === 0 ? Images.LinePointActive : Images.LinePoint} alt="line point" />
                    <div className="flex space-between flex-1">
                      <div>
                        <div className="weight-700 mt-1 s-16">{history.title}</div>
                        <div className="s-14 mute mt-1">{history.description || '-'}</div>
                      </div>
                      <div className="s-14 mute">
                        {moment(new Date(history.timestamp)).format('HH.mm')}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Box>
        </div>
      );
    }
    return (
      <div className="info-card mt-3">
        <h3>Assign courier</h3>
        <Divider sx={{ my: 2 }} />
        <div>
          <label>Choose courier</label>
          <Autocomplete
            autoComplete
            options={couriers}
            value={choosenCourier}
            onChange={(e, newVal) => setChoosenCourier(newVal)}
            getOptionLabel={(opt) => opt.front_name || ''}
            renderOption={(optProp, opt) => (
              <Box sx={{ px: 2, py: 1 }} {...optProp} className="flex gap-8 align-items-center link" style={{ gap: '8px !important' }}>
                <img src={opt.profile_picture} alt="profile_pict" width="40" height="40" className="courier-opt" style={{ borderRadius: 50 }} />
                <div>
                  <div className="weight-700">{opt.front_name}</div>
                  <div className="s-14 mute">{opt.id}</div>
                </div>
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Choose courier"
                InputProps={{
                  ...params.InputProps,
                }}
                size="small"
              />
            )}
          />
          <div className="s-12 mute mt-3">
            <strong>{couriers.length}</strong>
            {' '}
            Available couriers
          </div>
        </div>
      </div>
    );
  };

  const renderSubmitText = () => {
    switch (activeStep) {
      case 1: if (selectedRequest.delivery_type?.icon === 'warehouse') {
        return 'Accepting item';
      } return 'Proceed';
      case 2: {
        if (selectedRequest.driver) {
          return 'Accepting item';
        }
        return 'Assign courier';
      }
      case 3: return 'Accepting item';
      case 4: return 'Finish';
      default: return 'Proceed';
    }
  };

  return (
    <Elements.AdminPageBase
      title="Dashboard"
      breadcrumbs={(
        <div className="mt-3">
          <Link to="/" className="link weight-700 black">Dashboard</Link>
          {' '}
          / New request out
        </div>
    )}
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbar.open} autoHideDuration={10000} onClose={closeSnackbar}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity || 'success'}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <div className={classes.root}>
        <div className="mt-4">
          <div className="flex align-items-center flex-center">
            <div className="center">
              <img src={getImage('RequestOut', 1)} alt="Request in order data" />
              <div className={`mt-1 s-14 ${activeStep === 1 && 'weight-700'}`}>Request in order data</div>
            </div>
            {selectedRequest.delivery_type?.icon !== 'warehouse'
            && (
            <>
              <img src={Images.LongDivider} alt="LongDivider" />
              <div className="center">
                <img src={getImage('Courier', 2)} alt="Courier assign" />
                <div className={`mt-1 s-14 ${activeStep === 2 && 'weight-700'}`}>Courier assign</div>
              </div>
            </>
            )}
            <img src={Images.LongDivider} alt="LongDivider" />
            <div className="center">
              <img src={getImage('Confirmation', 3)} alt="WConfirmation" />
              <div className={`mt-1 s-14 ${activeStep === 3 && 'weight-700'}`}>Customer Validation</div>
            </div>
          </div>
        </div>

        <div>
          <Grid container justifyContent="center" className="mt-3">
            <Grid item lg={8} sm={10} xs={12}>

              {activeStep === 2 && renderCourierSection()}

              {renderRequestInfo()}

              {renderOwnerInfo()}

              {renderItemInfo()}

              {/* {activeStep === 1 && renderBoxItems()} */}
              {selectedRequest.status !== 'Done'
              && (
              <div className="flex justify-end gap-16 mt-4">
                <Button sx={{ px: 4 }} variant="outlined" className="action btn-outlined" onClick={() => setUnproceed(true)} disabled={selectedRequest.status === 'Done'}>Unproceed</Button>
                {!!(activeStep === 3)
                && <Button sx={{ px: 4 }} variant="outlined" className="action btn-outlined" onClick={() => setActiveStep(3)} disabled={selectedRequest.status === 'Done'}>Back</Button>}

                <Button sx={{ px: 4 }} variant="contained" className="action btn-contained" onClick={wantToContinue}>{renderSubmitText()}</Button>
              </div>
              )}
            </Grid>
          </Grid>

        </div>

      </div>

      <Elements.ConfirmationModal
        open={unproceed}
        desc={(
          <div>
            Are you sure want to unproceed this
            <br />
            Request? this process cannot be undone
          </div>
        )}
        handleClose={() => setUnproceed(false)}
        handleAgree={() => navigate(ROUTES.home())}
      />
      <Elements.ConfirmationModal
        open={activeStep === 1 && openConfirm}
        desc={(
          <div>
            Are you sure want to proceed
            {' '}
            <br />
            this request out pickup order request?
          </div>
        )}
        handleClose={closeModalConfirm}
        handleAgree={changeStep(2)}
      />
      <Elements.ConfirmationModal
        open={activeStep === 2 && openConfirm}
        desc={(
          <div>
            Assign pick up order request
            <br />
            to this Courier?
          </div>
        )}
        handleClose={closeModalConfirm}
        handleAgree={handleAssignCourier}
        isLoading={isLoading}
      />
      <Elements.ConfirmationModal
        open={activeStep === 3 && openConfirm}
        desc={(
          <div>
            Before confirming the item validation process,
            make sure to recheck again the item and information data!
          </div>
        )}
        handleClose={closeModalConfirm}
        handleAgree={handleAssignItemsToBox}
        isLoading={isLoading}
      />
      <Elements.ConfirmationModal
        open={activeStep === 4 && openConfirm}
        desc={(
          <div>
            Before you finish the request in order
            <br />
            make sure all of data are rights and filled up
          </div>
        )}
        handleClose={closeModalConfirm}
        handleAgree={() => updateStatus('Done')}
        isLoading={isLoading}
      />
    </Elements.AdminPageBase>
  );
}

function BoxToValidate({
  selectedBox, index, updateDigitalBox,
}) {
  const [hideBox, setHideBox] = useState(false);

  useEffect(() => {
    const itemIds = [];
    Object.keys(selectedBox).forEach((key) => {
      itemIds.push(selectedBox[key].id);
    });
  }, [selectedBox]);

  const [fields] = useState({
    warehouse_notes: '',
    box_code: '',
    is_verified_item_status: true,
  });

  useEffect(() => {
    updateDigitalBox(fields);
  }, [fields]);

  return (
    <Box sx={{
      borderRadius: 2,
      border: '1px solid #DADADA',
      p: 2,
      mt: 2,
    }}
    >
      <div className="flex space-between link" onClick={() => setHideBox(!hideBox)}>
        <div className="weight-700">
          {' '}
          Box
          {' '}
          {index + 1}

        </div>
        {hideBox
          ? <ExpandMoreRounded fontSize="medium" />
          : <ExpandLessRounded fontSize="medium" />}
      </div>

      <div hidden={hideBox}>
        {Object.keys(selectedBox).map((itemKey, i) => (
          <BoxItemData
            key={i}
            index={i}
            data={selectedBox[itemKey]}
          />
        ))}
      </div>
    </Box>
  );
}
